import { URL, handleErrors } from "./depannageActions"
import { getParams } from "../../utilities/Addons"
import { catchApiError } from "./apiHelpers"

export const FETCH_FACTURATION_BEGIN = "FETCH_FACTURATION_BEGIN"
export const FETCH_FACTURATION_SUCCESS = "FETCH_FACTURATION_SUCCESS"
export const FETCH_FACTURATION_ERROR = "FETCH_FACTURATION_ERROR"

export const fetchFacturationBegin = () => ({
	type: FETCH_FACTURATION_BEGIN,
})

export const fetchFacturationSuccess = (payload) => ({
	type: FETCH_FACTURATION_SUCCESS,
	payload,
})

export const fetchFacturationError = (error) => ({
	type: FETCH_FACTURATION_ERROR,
	payload: error,
})

export function fetchFacturation(kwargs) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchFacturationBegin())
		return fetch(`${URL}api/facturation${getParams(kwargs)}`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchFacturationSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchFacturationError))
	}
}
